import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';
import { RecommendedHealers } from '../../infra/adapters/luminara/healer-selection/dto/recommended-healers';

export interface MySelectionsState {
  isLoadingHealerRecommendations: boolean;
  healerRecommendations: RecommendedHealers[];
  loadingHealerRecommendationsError?: string;

  isLoadingHealerRecommendation: boolean;
  healerRecommendation: RecommendedHealers | null;
  loadingHealerRecommendationError?: string;
}

export const initialMySelectionsState = () =>
  ({
    isLoadingHealerRecommendations: true,
    healerRecommendations: [],
    isLoadingHealerRecommendation: true,
    healerRecommendation: null
  } as MySelectionsState);

export interface MySelectionsAction {
  type:
    | 'LOAD_ALL_HEALER_RECOMMENDATION_SUCCESS'
    | 'LOAD_ALL_HEALER_RECOMMENDATION_FAILURE'
    | 'SET_LOADING_ALL_HEALER_RECOMMENDATION'
    | 'LOAD_HEALER_RECOMMENDATION_BY_ID_SUCCESS'
    | 'LOAD_HEALER_RECOMMENDATION_BY_ID_FAILURE'
    | 'SET_LOADING_HEALER_RECOMMENDATION_BY_ID';
  payload?: any;
}

const mySelectionsReducer = (state: MySelectionsState = initialMySelectionsState(), action: MySelectionsAction): MySelectionsState => {
  switch (action.type) {
    case 'LOAD_ALL_HEALER_RECOMMENDATION_SUCCESS':
      return {
        ...state,
        healerRecommendations: action.payload,
        isLoadingHealerRecommendations: false,
      };
    case 'LOAD_ALL_HEALER_RECOMMENDATION_FAILURE':
      return { ...state, loadingHealerRecommendationsError: extractMessageFromError(action.payload), isLoadingHealerRecommendations: false };
    case 'SET_LOADING_ALL_HEALER_RECOMMENDATION': {
      return { ...state, isLoadingHealerRecommendations: action.payload };
    }
    case 'LOAD_HEALER_RECOMMENDATION_BY_ID_SUCCESS':
      return {
        ...state,
        healerRecommendations: action.payload,
        isLoadingHealerRecommendation: false,
      };
    case 'LOAD_HEALER_RECOMMENDATION_BY_ID_FAILURE':
      return { ...state, loadingHealerRecommendationError: extractMessageFromError(action.payload), isLoadingHealerRecommendation: false };
    case 'SET_LOADING_HEALER_RECOMMENDATION_BY_ID': {
      return { ...state, isLoadingHealerRecommendation: action.payload };
    }
    default:
      return state;
  }
};

export default mySelectionsReducer;
